import { getJSONSchemaURL, Y42MetadataGitModel } from '@y42/feature/json-schema';
import { AbstractFeatureEntityState, AbstractFeatureStoreModel, AbstractFeatureUIModel } from '@y42/feature/models';
import {
  AdvancedFilterSettings,
  CheckboxFilterSettings,
  DateFilterSettings,
  DropdownFilterSettings,
  FilterType,
  MultiselectFilterSettings,
  VisualizationFilterSettings,
} from '@y42/json-schema';

export class VisualizationFilterSettingsGitModel extends VisualizationFilterSettings {
  constructor(model: VisualizationFilterStoreModel) {
    super();
    this.$schema = getJSONSchemaURL('visualization-filter-settings');
    this.datasource_table_path = model?.datasource_table_path;
    this.field_name = model?.field_name;
    this.data_type = model?.data_type;
    this.type = model?.type;
    this.operations = model?.operations;
    this.options = model?.options;
  }
  /**
   * DO NOT MODIFY ANY PROPERTIES HERE.
   * TO LEARN HOW TO MODIFY CLASSES GENERATED FROM JSON-SCHEMA
   * TAKE A LOOK AT https://y42-com.slab.com/posts/working-with-json-schemas-1hz2gcvj
   */
}

export class VisualizationFilterStoreModel<T extends FilterType = FilterType>
  extends Y42MetadataGitModel
  implements AbstractFeatureStoreModel
{
  constructor(model: VisualizationFilterStoreModel<T>) {
    super(model);
    this.$name = model.$name;
    this.$path = model.$path;
    this.$level = model.$level;

    this.type = model.type;
    this.datasource_table_path = model.datasource_table_path;
    this.field_name = model.field_name;
    this.data_type = model.data_type;
    this.operations = model.operations;
    this.options = model.options;
  }

  $name: string;
  $path: string;
  $level: number;

  type?: T;
  datasource_table_path?: VisualizationFilterSettingsGitModel['datasource_table_path'];
  field_name?: VisualizationFilterSettingsGitModel['field_name'];
  data_type?: VisualizationFilterSettingsGitModel['data_type'];
  operations?: VisualizationFilterSettingsGitModel['operations'];
  options?: (typeof FilterTypeSettingsModel)[T];
}

export type VisualizationFilterUIModel<T extends FilterType = FilterType> = AbstractFeatureUIModel &
  VisualizationFilterStoreModel<T>;

export type VisualizationFilterState = AbstractFeatureEntityState<VisualizationFilterStoreModel>;

export interface CreateVisualizationFilterParams {
  settings: Omit<VisualizationFilterSettings, '$schema'>;
}

export const FilterTypeSettingsModel = {
  [FilterType.Dropdown]: [] as DropdownFilterSettings,
  [FilterType.Multiselect]: [] as MultiselectFilterSettings,
  [FilterType.Date]: {} as DateFilterSettings,
  [FilterType.Checkbox]: { layout: 'toggle' } as CheckboxFilterSettings,
  [FilterType.Advanced]: {} as AdvancedFilterSettings,
} as const;
